import { createStore, createHook, createContainer, Action } from 'react-sweet-state';

import { messages } from './constants/messages';
import { JiraIssue, Message, Store } from './constants/types';
import { AnimationSteps, stepsLength } from './constants/ui';

const initialState: Store = {
	animationStep: AnimationSteps.CARD_TYPING,
	isCreateButtonFocused: false,
	todoCol: [] as Array<JiraIssue>,
	inProgressCol: [] as Array<JiraIssue>,
	doneCol: [] as Array<JiraIssue>,
	messages: messages,
};

const genericRestartAction =
	(): Action<Store> =>
	({ setState, getState }) => {
		const { messages } = getState();
		setState({
			...initialState,
			messages,
			isCreateButtonFocused: true,
		});
	};

const actions = {
	animateIssue:
		(animatedCardData: JiraIssue): Action<Store> =>
		({ setState, getState }) => {
			const { todoCol } = getState();
			const todoColAppend = todoCol.concat([animatedCardData]);
			setState({ todoCol: todoColAppend });
		},
	nextAnimationStep:
		(): Action<Store> =>
		({ setState, getState, dispatch }) => {
			const { animationStep } = getState();
			if (animationStep === stepsLength - 1) {
				dispatch(genericRestartAction());
				return;
			}
			setState({ animationStep: animationStep + 1 });
		},
	restartDemo:
		(): Action<Store> =>
		({ setState, getState }) => {
			const { messages, inProgressCol, doneCol } = getState();
			setState({
				...initialState,
				messages,
				inProgressCol,
				doneCol,
				isCreateButtonFocused: true,
			});
		},
	setTodoCol:
		(colInfo: Array<JiraIssue>): Action<Store> =>
		({ setState }) => {
			setState({ todoCol: colInfo });
		},
	setDoneCol:
		(colInfo: Array<JiraIssue>): Action<Store> =>
		({ setState }) => {
			setState({ doneCol: colInfo });
		},
	setInProgressCol:
		(colInfo: Array<JiraIssue>): Action<Store> =>
		({ setState }) => {
			setState({ inProgressCol: colInfo });
		},
	initializeTour:
		(messages: Message): Action<Store> =>
		({ setState }) => {
			setState({ ...initialState, messages });
		},
	transitionToInProgress:
		(): Action<Store> =>
		({ setState, getState }) => {
			const { todoCol, inProgressCol } = getState();
			const todoColPop = todoCol[todoCol.length - 1];
			const todoCopy = todoCol.slice(0, -1);
			if (todoColPop) {
				const inProgressAppend = inProgressCol.concat([todoColPop]);
				setState({
					todoCol: todoCopy,
					inProgressCol: inProgressAppend,
				});
			}
		},
	transitionToDone:
		(): Action<Store> =>
		({ setState, getState }) => {
			const { inProgressCol, doneCol } = getState();
			const inProgColPop = inProgressCol[inProgressCol.length - 1];
			const inProgCopy = inProgressCol.slice(0, -1);
			if (inProgColPop) {
				const doneColAppend = doneCol.concat([inProgColPop]);
				setState({ inProgressCol: inProgCopy, doneCol: doneColAppend });
			}
		},
};

const InteractiveBoardStore = createStore({
	initialState,
	actions,
	name: 'jsw-interactive-board-store',
});

const getMessages = (state: Store) => state.messages;
export const useMessages = createHook(InteractiveBoardStore, {
	selector: getMessages,
});
export const useAnimatedJiraBoardStore = createHook(InteractiveBoardStore);

export const AnimatedJiraBoardContainer = createContainer(InteractiveBoardStore);
